import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  static values = {
    gender: String,
    country: String,
    registration: String,
    newRegister: Boolean,
    mailDelivery: String,
    userLogin: String
  };

  connect() {
    if (this.userLoginValue === "true") {
      window.dataLayer = window.dataLayer || [];
      window.dataLayer.push({
        gender: this.genderValue,
        country: this.countryValue,
        registration: this.registrationValue,
        mailDelivery: this.mailDeliveryValue,
      });

      if (this.newRegisterValue) {
        window.dataLayer.push({ event: "CID_complete_registration" });
      }
    }
    (function(w,d,s,l,i){w[l]=w[l]||[];w[l].push({"gtm.start":
      new Date().getTime(),event:"gtm.js"});var f=d.getElementsByTagName(s)[0],
      j=d.createElement(s),dl=l!="dataLayer"?"&l="+l:"";j.async=true;j.src=
      "https://www.googletagmanager.com/gtm.js?id="+i+dl;f.parentNode.insertBefore(j,f);
    })(window,document,"script","dataLayer","GTM-WZJ77MJ");
  }
}
